import React from "react";
import { useIntl } from "react-intl";

export default function Footer() {
  const { formatMessage } = useIntl();
  return (
    <footer>
      <p>{formatMessage({ id: "hyvendor.footer" })}</p>
    </footer>
  );
}
